import { z } from 'zod';

/**
 * Schema for environment variables validation
 */
const envSchema = z.object({
  VITE_API_BASE_URL: z.string().url('VITE_API_BASE_URL must be a valid URL'),
});

/**
 * Validates environment variables against the schema
 * @throws Error if validation fails
 */
export function validateEnv(): void {
  try {
    envSchema.parse(import.meta.env);
  } catch (error) {
    if (error instanceof z.ZodError) {
      const issues = error.issues.map(issue => 
        `${issue.path.join('.')}: ${issue.message}`
      ).join(', ');
      
      throw new Error(
        `Environment validation failed: ${issues}. ` +
        'Please check your .env file and ensure all required variables are properly defined.'
      );
    }
    throw error;
  }
}

/**
 * Initializes and validates environment configuration
 * @returns Validated environment object
 * @throws Error if validation fails
 */
export function initializeEnv() {
  validateEnv();
  const validatedEnv = envSchema.parse(import.meta.env);
  
  return {
    apiBaseUrl: validatedEnv.VITE_API_BASE_URL,
  } as const;
}

/**
 * Centralized environment configuration object
 */
export const env = initializeEnv(); 